// Copyright (c) 2021 WiseTime. All rights reserved.

import React from "react"
import { Trans } from "@lingui/react"
import styled from "styled-components/macro"
import {
  ImmediatelyDeleteTimeRowsRequest,
  TimeRow,
  UnTrashTimeRowsRequest
} from "../../../generated/wisetime/user/timeline/v4/timeline_pb"
import { ActionPaneButton, SecondaryButton, ActionPaneButtonsWrapper } from "../../shared/styles"
import * as TimelineActions from "../actions"
import { useDispatch } from "react-redux"

const DeleteButton = styled(ActionPaneButton)`
  background: ${({ theme }): string => theme.colors.cinnabar};
  color: white;
  transition: background-color .3s ease;

  &:hover {
    background-color: ${({ theme }): string => theme.colors.fireBrick};
  }
`

type Props = {
  timeRows: TimeRow.AsObject[],
}

const ActionPaneButtonsTrash = ({ timeRows }: Props): React.ReactElement<Props> | null=> {
  const dispatch = useDispatch()

  const undeletedTrashedTimeRows = (): void => {
    if (timeRows) {
      const request = new UnTrashTimeRowsRequest().setTimeRowIdsList(timeRows.map(r => r.id))
      dispatch(TimelineActions.untrashTimeRows(request))
    }
  }

  const deleteTrashedTimeRowsPermanently = (): void => {
    if (timeRows) {
      const request = new ImmediatelyDeleteTimeRowsRequest().setTimeRowIdsList(timeRows.map(row => row.id))
      dispatch(TimelineActions.immediatelyDeleteTimeRows(request))
    }
  }

  if (timeRows.length > 0) {
    return (
      <ActionPaneButtonsWrapper>
        <SecondaryButton type="button" onClick={undeletedTrashedTimeRows}>
          <Trans id="button_restore" message="Restore"/>
        </SecondaryButton>
        <DeleteButton type="button" onClick={deleteTrashedTimeRowsPermanently}>
          <Trans id="button_delete_immediately" message="Delete Immediately"/>
        </DeleteButton>
      </ActionPaneButtonsWrapper>
    )
  }
  return null
}

export default ActionPaneButtonsTrash
